<script lang="ts">
    import type { Question } from "../../Model/Question";
    import { getContext, } from "svelte";
    import type { GetAnswerFn, OptionState, SaveAnswerFn } from "../../global";
    import type { Answer } from "../../Model/Answer";
    import type { Readable } from "svelte/store";
    import QuestionBox from "./QuestionBox.svelte";
    import AlertSaveError from "../AlertSaveError.svelte";

    export let question: Question;

    const getAnswer: GetAnswerFn = getContext('getAnswer');
    const readonlyForm: Readable<boolean> = getContext('readonlyForm');
    const saveAnswer: SaveAnswerFn = getContext('saveAnswer');

    let isSaving = false;
    let saveError = false;
    let value: Readable<any>;
    let selection: string[];
    let answer: Answer;
    let options: OptionState[];
    
    $: setupQuestion(question);
    $: updateSelection($value);

    function setupQuestion(question: Question): void {
        answer = getAnswer(question.id);
        value = answer.valueReadable;
        options = question.options.questionOptions;
    }

    function updateSelection(value: string): void {
        selection = value.split(',').filter(option => !!option.trim());
    }

    async function toggleOption(option: OptionState): Promise<void> {
        if (!answer || $readonlyForm) {
            return;
        }
        
        try {
            isSaving = true;

            if (selection.includes(option.id)) {
                selection = selection.filter(id => id !== option.id);
            } else {
                selection = [...selection, option.id];
            }

            answer.value = selection.join(',');
            
            await saveAnswer(answer);
            saveError = false;
        } catch (error) {
            saveError = true;
        } finally {
            isSaving = false;
        }
    }

</script>

<QuestionBox {question} {isSaving}>
    {#each options as option}
        <div class="form-check">
            <input
                class="form-check-input"
                type="checkbox"
                disabled={$readonlyForm}
                name={question.id}
                id={`radio-${option.id}`}
                checked={selection.includes(option.id)}
                on:change={() => toggleOption(option)}>
            <label class="form-check-label" for={`radio-${option.id}`}>{option.text}</label>
        </div>
    {/each}

    {#if saveError}
        <AlertSaveError />
    {/if}
</QuestionBox>

